import $ from 'jquery';
import { fontLoader } from './fontFaceObserver';
import 'nanoscroller';
import throttle from 'lodash.throttle';


export const init = () => {
	const $win = $(window);
	const $scroll = $('.scroll');
	const BOTTOM_CLASS = 'is-bottom';
	const OPTIONS = {
		contentClass: 'scroll__content',
		sliderClass: 'scroll__slider',
		paneClass: 'scroll__pane',
	};

	const onUpdate = (event, values) => {
		const $scroll = $(event.currentTarget);
		const { position, maximum } = values;

		checkBottom($scroll, position, maximum);
	};

	const checkBottom = ($scroll, position, maximum) => {
		if (position === maximum) {
			$scroll.addClass(BOTTOM_CLASS);
		} else {
			$scroll.removeClass(BOTTOM_CLASS);
		}
	};

	const checkScroll = () => {
		requestAnimationFrame(() => {
			$scroll.each((_, item) => {
				const $scroll = $(item);
				const $pane = $scroll.find('.scroll__pane');
				const isPaneVisible = $pane.is(':visible');
				let maximum = 0;

				if (isPaneVisible) {
					maximum = 1;
				}

				checkBottom($scroll, 0, maximum);
			});
		});
	};


	fontLoader.then(() => {
		$scroll
			.nanoScroller(OPTIONS)
			.on('update', onUpdate);

		checkScroll();
	});


	$win.on('resize', throttle(checkScroll, 100));
};



// WEBPACK FOOTER //
// ./src/js/components/scroll.js